<script lang="ts" context="module">
	export let KEY_BANNER = "banner";
</script>
<script lang="ts">
	import { goto } from "$app/navigation";
	import type { LandingItemContext, RealBanner } from "$lib/def/landing";
	import { fetch$ } from "$lib/serv/core/cache";
	import { SPKEYS, getDB } from "$lib/serv/groc-landing";
	import { LOCATION_PROPS } from "$lib/serv/locations";
	import { query } from "$lib/util/url";
	import { EMPTY } from "rxjs";
	import { getContext } from "svelte";
	import Landing from "$lib/ui/home/groc/Landing.svelte";
	import Error from "$lib/ui/shared/Error.svelte";
	import LazyImage from "$lib/ui/shared/LazyImage.svelte";
	import LoadingIcons from "$lib/ui/shared/LoadingIcons.svelte";
	import CarouselV3 from "$lib/ui/layout/CarouselV3.svelte";

	export let endpoint: string | undefined;
	export let id: string | null;
	export let pageUrl: URL;

	let store: string | undefined;
	$: [, store] = endpoint?.split("/") ?? [];

	const { landingItems, cacheAge } = getContext('endpoints') as LandingItemContext;

	$: cache = endpoint ? fetch$<RealBanner[]>(new URL(landingItems + endpoint), SPKEYS, { db: getDB(), msMaxCacheAge: cacheAge.medium }) : EMPTY;

</script>

{#if id}
	{@const banner = $cache?.payload?.find((b) => b.uuid === id)}
	{#if banner && store}
		<Landing {store} item={banner} on:product />
	{:else if !$cache || $cache.loading}
		<LoadingIcons />
	{:else}
		<Error
			title="Campaign not found"
			description="We could not find the campaign you're looking for."
			extra={""}
			showInput={false}
			buttonText={`Back to home`}
			buttonHref={query(pageUrl).remove(KEY_BANNER).toUrl()}
		/>
	{/if}

{:else}
	<CarouselV3
		cache={$cache}
		type="banners large"
		key={(payload) => payload}
		id="large-banners">
		{#snippet children({ item: banner })}
			<a href={query(pageUrl).set(KEY_BANNER, banner.uuid).toUrl()}
				class="item"
				class:cropped={banner.cropped}
				class:portrait={banner.portrait}
				style:background-color={banner.colours?.background}
				style:color={banner.colours?.title}
				data-testid={`banner-link-${banner.uuid}`}
			>
				<div class="relative">
					<div class="image">
						<LazyImage image={[banner.image, 500]} alt={banner.title} id="banner" />
					</div>
					{#if !banner.image_only}
						<div class="text">
							{#if banner.title}
								<h4 class="title body-l bold" data-testid="banner-title">{banner.title}</h4>
							{/if}
							{#if banner.sub_title}
								<p class="subtitle body-l book" style:color={banner.colours?.subtitle} data-testid="banner-subtitle">{banner.sub_title}</p>
							{/if}
							{#if banner.call_to_action}
								<button
									style:background-color={banner.colours?.button}
									style:color={banner.colours?.button_text}
									data-testid="banner-cta"	
								>{banner.call_to_action}</button>
							{/if}
						</div>
					{/if}
				</div>
			</a>
		{/snippet}
	</CarouselV3>
{/if}
